module.exports = __webpack_public_path__ + "assets/img/gd5.2baf87a4.jpg";